import React, { useEffect } from 'react';
import { LanguageProvider } from '../context/LanguageContext';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { BlueprintHero } from '../components/blueprint/BlueprintHero';
import { BlueprintNav } from '../components/blueprint/BlueprintNav';
import { OverviewSection, GuestJourneySection, FivePortalsSection, StoryArcSection, FloorMapSection, FinalRevealSection } from '../components/blueprint/BlueprintExperience';
import { FoodDrinkSection, MusicSoundSection, AromaScentSection } from '../components/blueprint/BlueprintSensory';
import { SponsorsSection, OntarioTourismSection, GurdwarasSection, PreviousSponsorsSection, SchoolsSection, WeddingPlannersSection, ResortSalesSection, InvestorsSection } from '../components/blueprint/BlueprintPartners';
import { DownloadsSection, FinalCTASection } from '../components/blueprint/BlueprintResources';
import { TeamSection, teamIcons, GeneralInfoDivider, ProductionTeamsDivider, AThinkStudioContent, HistoryTeamContent, PRMarketingTeamContent, FinanceTeamContent } from '../components/blueprint/BlueprintTeams';
export function BlueprintPage() {
  useEffect(() => {
    document.body.classList.add('bg-[#0a0a0f]', 'text-white', 'overflow-x-hidden');
    return () => {
      document.body.classList.remove('bg-[#0a0a0f]', 'text-white', 'overflow-x-hidden');
    };
  }, []);
  return <LanguageProvider data-id="element-3760" data-mp="31nayz8d2559n">
      <div className="relative bg-[#0a0a0f] min-h-screen" data-id="element-3761" data-mp="31mj3dxjgn7jd">
        <Navbar data-id="element-3762" data-mp="35p60acuzninf" />
        <BlueprintNav data-id="element-3763" data-mp="35qquu2haz1la" />

        <main className="w-full xl:pl-56" data-id="element-3764" data-mp="35q7ayg83e34m">
          <BlueprintHero data-id="element-3765" data-mp="3aoilyua4ijof" />

          {/* ─── GENERAL INFORMATION ─── */}
          <GeneralInfoDivider data-id="element-3766" data-mp="3amo983909xvf" />
          <OverviewSection data-id="element-3767" data-mp="1bbwp8gmsnp32" />
          <GuestJourneySection data-id="element-3768" data-mp="1bcpufd63u6j3" />
          <StoryArcSection data-id="element-3769" data-mp="1bdra5uy2fh75" />

          {/* ─── PRODUCTION TEAMS ─── */}
          <ProductionTeamsDivider data-id="element-3770" data-mp="1gbj0wlmz4x9r" />

          <div className="container mx-auto px-6 max-w-5xl" data-id="element-3771" data-mp="1gckmvl5j3469">
            <TeamSection teamNumber={1} teamName="Secret Location" lead="Secret Location" role="Creating the immersive environment — portals, projections, floor map, and spatial design" icon={teamIcons.secretLocation} defaultExpanded={true} data-id="element-3772" data-mp="2jmgfato33f9q">
              <FivePortalsSection data-id="element-3773" data-mp="2nplaeb5u4eoc" />
              <FloorMapSection data-id="element-3774" data-mp="32jpw0320yena" />
              <FinalRevealSection data-id="element-3775" data-mp="32iokxyl0ds5k" />
              <MusicSoundSection data-id="element-3776" data-mp="2xlg0frce1c15" />
            </TeamSection>

            <TeamSection teamNumber={2} teamName="AThink Studio" lead="AThink Studio (with Seadance)" role="Generative AI visuals and acting videos in Punjabi and English" icon={teamIcons.athinkStudio} data-id="element-3777" data-mp="2xkwrh04ptxz9">
              <AThinkStudioContent data-id="element-3778" data-mp="3lbsivw59er5z" />
            </TeamSection>

            <TeamSection teamNumber={3} teamName="Scent & Drink Team" lead="Mystical Mocktails" role="Designing the aromatic journey and drink pairings for each portal" icon={teamIcons.scentDrink} data-id="element-3779" data-mp="3gcfwfciavm3x">
              <AromaScentSection data-id="element-3780" data-mp="3pzjsorqcn4rs" />
              <div className="p-8 md:p-10 border-t border-[#d4a017]/10" data-id="element-3781" data-mp="3pyi5xpzz0tu8">
                <h3 className="font-serif text-2xl text-[#f5f0e8] mb-4" data-id="element-3782" data-mp="3uycyrz3b3thx">
                  Drink Pairings
                </h3>
                <p className="text-[#f5f0e8]/50 font-light leading-relaxed mb-6" data-id="element-3783" data-mp="3h66sr5tvb2w7">
                  Working closely with the Food Team, Mystical Mocktails designs
                  bespoke non-alcoholic pairings that match the aromatic profile
                  of each portal.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3784" data-mp="3c96ngx4ue465">
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3785" data-mp="2y8m5g36r4cdp">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3786" data-mp="329xvuaxg91my">
                      Akali Phula Singh
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3787" data-mp="2v5pqajc028gi">
                      Saffron lassi with black pepper
                    </p>
                  </div>
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3788" data-mp="2lgfuase1c5n4">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3789" data-mp="2gi4men7aw57j">
                      Lehna Singh Majithia
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3790" data-mp="2ch1b8e076xcn">
                      Cardamom cold brew
                    </p>
                  </div>
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3791" data-mp="22hk6pzwompi9">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3792" data-mp="1xj8slczctsu8">
                      Hari Singh Nalwa
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3793" data-mp="pfiayee6aca">
                      Kashmiri kahwa
                    </p>
                  </div>
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3794" data-mp="4965lsjcbrwx">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3795" data-mp="8a860cozua0h">
                      Fakir Azizuddin
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3796" data-mp="d1zqc5hk3ji6">
                      Rose sherbet with edible gold
                    </p>
                  </div>
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3797" data-mp="3hfofxtctqcga">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3798" data-mp="3lgi0ccr2594f">
                      Maharani Jind Kaur
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3799" data-mp="3qf2z07qnvkqr">
                      Masala chai with honey
                    </p>
                  </div>
                </div>
              </div>
            </TeamSection>

            <TeamSection teamNumber={4} teamName="Food Team" lead="TBD" role="Food design, preparation, and synchronized serving during the experience" icon={teamIcons.food} data-id="element-3800" data-mp="15rzshwkoaihc">
              <FoodDrinkSection data-id="element-3801" data-mp="g0oq7qhdocb0" />
            </TeamSection>

            <TeamSection teamNumber={5} teamName="Sales Team" lead="TBD" role="Promotion, partnerships, and driving ticket sales across all channels" icon={teamIcons.sales} data-id="element-3802" data-mp="uyh6wlynv6qs">
              <SponsorsSection data-id="element-3803" data-mp="2acvrkxbm1gp" />
              <OntarioTourismSection data-id="element-3804" data-mp="3tgmorzs9mqke" />
              <GurdwarasSection data-id="element-3805" data-mp="3thpei4duqmyq" />
              <PreviousSponsorsSection data-id="element-3806" data-mp="3te9zt2o3bfxu" />
              <SchoolsSection data-id="element-3807" data-mp="c0ehw76459sz" />
              <WeddingPlannersSection data-id="element-3808" data-mp="c1fwglmc8efg" />
              <ResortSalesSection data-id="element-3809" data-mp="796afgocfyig" />
              <InvestorsSection data-id="element-3810" data-mp="78wmdymv01fe" />
            </TeamSection>

            <TeamSection teamNumber={6} teamName="History Team" lead="Ajaypal" role="Ensuring historical accuracy across all content, visuals, and narrative" icon={teamIcons.history} data-id="element-3811" data-mp="3fozs3yuevg13">
              <HistoryTeamContent data-id="element-3812" data-mp="1q69j4f7g6q0j" />
            </TeamSection>

            <TeamSection teamNumber={7} teamName="PR & Marketing Team" lead="TBD" role="Public relations, media outreach, and marketing to drive attendance" icon={teamIcons.prMarketing} data-id="element-3813" data-mp="1uyuc5eij4z30">
              <PRMarketingTeamContent data-id="element-3814" data-mp="28yc5862uyyi6" />
            </TeamSection>

            <TeamSection teamNumber={8} teamName="Finance Team" lead="TBD" role="Budget management, revenue projections, and ensuring commercial viability" icon={teamIcons.finance} data-id="element-3815" data-mp="28z54klzhmlqa">
              <FinanceTeamContent data-id="element-3816" data-mp="23yhcry3fq0v0" />
            </TeamSection>
          </div>

          {/* ─── RESOURCES ─── */}
          <DownloadsSection data-id="element-3817" data-mp="ohpduvb97py9" />
          <FinalCTASection data-id="element-3818" data-mp="oklb0hfa2aln" />
        </main>

        <div className="xl:pl-56" data-id="element-3819" data-mp="sklrs8pumxvv">
          <Footer data-id="element-3820" data-mp="slnb10h0qqoo" />
        </div>
      </div>
    </LanguageProvider>;
}